import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-261" data-mp="3fxku09kz63jg">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-clay text-clay" aria-hidden="true" data-id="element-262" data-mp="36yzeknasv4mw" data-mpi={index} />)}
    </div>;
}
export function Testimonials() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const updateEdges = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    setAtStart(track.scrollLeft <= 4);
    setAtEnd(track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
  }, []);
  useEffect(() => {
    updateEdges();
    const track = trackRef.current;
    if (!track) return;
    track.addEventListener('scroll', updateEdges, {
      passive: true
    });
    window.addEventListener('resize', updateEdges);
    return () => {
      track.removeEventListener('scroll', updateEdges);
      window.removeEventListener('resize', updateEdges);
    };
  }, [updateEdges]);
  const scrollByCard = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('li');
    const step = card ? card.clientWidth + 24 : track.clientWidth * 0.85;
    track.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
  };
  return <section className="bg-paper" data-id="element-263" data-mp="q764mq3qy1uj">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-264" data-mp="q63famm2o7gq">
        <SectionHeading eyebrow="Experiencias" title={<>
              Personas que empezaron a mirar su hogar{' '}
              <span className="text-clay" data-id="element-266" data-mp="1iuij0czr73cr">de otra manera</span>
            </>} data-id="element-265" data-mp="v4xuzfoqtfwm" />

        <div className="mx-auto mt-12 max-w-5xl sm:mt-16" data-id="element-267" data-mp="1nma6ufriyuz7">
          <ul ref={trackRef} className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-268" data-mp="1nnv0m360m9w0">
            {testimonials.map(testimonial => <li key={testimonial.name} className="flex w-[88%] shrink-0 snap-start flex-col rounded-2xl bg-cream p-6 sm:w-[calc((100%-24px)/2)] sm:p-8 lg:w-[calc((100%-48px)/3)]" data-id="element-269" data-mp="1sgtf5a3cmurg">
                <Stars data-id="element-270" data-mp="1jhptpzgpm39s" />

                <p className="mt-5 flex-1 text-[15px] leading-[1.75] text-ink sm:text-[15.5px]" data-id="element-271" data-mp="1jkkfbubglu4s">
                  {testimonial.quote}
                </p>

                <div className="mt-7 flex items-center gap-3.5 border-t border-sage-line pt-5" data-id="element-272" data-mp="19rmtbe79dn1f">
                  <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-273" data-mp="14ud4o0rp1fen" />
                  <div data-id="element-274" data-mp="vsneey9jsmig">
                    <p className="font-sans text-[14.5px] font-semibold text-ink" data-id="element-275" data-mp="vswvtxgj1lcj">
                      {testimonial.name}
                    </p>
                    <p className="text-[12.5px] text-ink-mute" data-id="element-276" data-mp="qvn9wrscjrtg">{testimonial.location}</p>
                  </div>
                </div>
              </li>)}
          </ul>

          <div className="mt-8 flex items-center justify-center gap-3" data-id="element-277" data-mp="37exlmvs3w3ls">
            <button type="button" onClick={() => scrollByCard(-1)} disabled={atStart} aria-label="Ver testimonios anteriores" className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-line bg-white text-ink shadow-card transition-colors duration-150 ease-out hover:bg-sage-tint disabled:cursor-not-allowed disabled:opacity-35" data-id="element-278" data-mp="3cek3jiivq80x">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-279" data-mp="2onemx1547bpk" />
            </button>
            <button type="button" onClick={() => scrollByCard(1)} disabled={atEnd} aria-label="Ver testimonios siguientes" className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-line bg-white text-ink shadow-card transition-colors duration-150 ease-out hover:bg-sage-tint disabled:cursor-not-allowed disabled:opacity-35" data-id="element-280" data-mp="2spt7pqscgljh">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-281" data-mp="1lwdej3zfbcgm" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}